<template>
<div>
    <div class="button__next text-white no-border add-new-payment-method" @click="showModal()">
        Add new payment method
    </div>
    <modal name="paymentModal" :min-height="400" height="auto" :shiftY="0.3" classes="whatswhat-modal payment-modal">
        <div class="payment-form-wrapper">
            <div class="close-modal" @click="closeModal()"><i class="icon-cross"></i></div>

            <input id="card-holder-name" class="input__text" style="margin-bottom: 10px;" placeholder="Card holder name" type="text" v-model="business_name">


            <!-- Stripe Elements Placeholder -->
            <div id="card-element" class="input__text"></div>

            <button id="card-button" class="button__next text-white no-border" @click="addPaymentMethod()">
                Add Payment Method
            </button>
        </div>
    </modal>
</div>
</template>


<script>

    export default {
        props: ['payment_intent_secret', 'stripe_key', 'name', 'add_pm_route'],
        data: function() {
            return {
                stripe: '',
                cardElement: '',
                business_name: ''
            }
        },
        methods: {
            closeModal() {
              this.$modal.hide('paymentModal');
            },
            showModal: function() {
                this.$modal.show('paymentModal')
                this.$nextTick(function () {
                    this.createCardElement()
                })
            },
            createCardElement() {
                setTimeout(() => {
                    this.stripe = Stripe(this.stripe_key);
                    const elements = this.stripe.elements();
                    this.cardElement = elements.create('card');
                    this.cardElement.mount('#card-element');
                }, 1000);
            },
            addPaymentMethod() {
                this.stripe.confirmCardSetup(
                    this.payment_intent_secret, {
                        payment_method: {
                            card: this.cardElement,
                            billing_details: {
                                name: this.business_name
                            }
                        }
                    }
                ).then(function(result) {
                    if (result.error) {
                      console.log(result.error.message);
                    } else {
                        console.log('success');
                        this.savePaymentMethod( result.setupIntent.payment_method );
                        this.cardElement.clear();
                        this.name = '';
                    }
                }.bind(this));
            },
            savePaymentMethod( method ){
                axios.post(this.add_pm_route, {
                    payment_method: method
                }).then( function(){
                    window.location.reload();
                }.bind(this));
            },
        },

        mounted () {
            this.business_name = this.name;
        }
    }
</script>